import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Dialog from '@Componentes/dialog';
import EstadoNaoIdeal from '@Componentes/estado-nao-ideal';
import CentralizaConteudo from '@Componentes/centraliza-conteudo';
import functions from '@Config/functions';
import lodash from 'lodash';
import {
  EventBus
} from '@Config/eventBus.js';
import router from '@Config/router';
import moment from 'moment-timezone';
import axios from '@Config/axios';
import BeeGridTable from 'beegridtable';
import Beelocale from 'beegridtable/src/locale';
import Toasted from 'vue-toasted';

import App from './App.vue';
import store from './store';
import '@Config/filters';
import '@Config/plugins';
import '@Config/directives';
import './consts/colors';
import '@Config/registerServiceWorker';
import './handler';
import 'beegridtable/dist/styles/beegridtable.css';
import './plugins/vuetify-money.js';
// import { messaging } from './config/firebase';

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(BeeGridTable, {
  locale: Beelocale,
  capture: true
});
Vue.use(Toasted, {
  icon: 'notifications_active'
});

// notificao personalizada this.$toasted.global.my_app_error()
Vue.toasted.register('my_app_error', 'Oops.. Something Went Wrong..', {
  type: 'error',
  icon: 'error_outline'
});
moment.locale('pt-BR');
moment.tz.setDefault('America/Sao_Paulo');

Vue.prototype.$lodash = lodash;
Vue.prototype.$functions = functions;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$http = axios;
// Vue.prototype.$messaging = messaging;

Vue.component('Dialog', Dialog);
Vue.component('EstadoNaoIdeal', EstadoNaoIdeal);
Vue.component('CentralizaConteudo', CentralizaConteudo);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
